import { InfoBox } from '@konova/ui/info-box';
import { Typography } from '@konova/ui/typography';
import { useTranslation } from 'react-i18next';
import classes from './general-error.module.scss';
import { FC, useEffect } from 'react';
import { Collapsible } from '@konova/ui/collapsible';
import { Card } from '@konova/ui/card';
import { Icon } from '@konova/ui/icon';
import { IconButton } from '@konova/ui/icon-button';
import { Container } from '@common/layout/container';
import { Button } from '@konova/ui/button';
import { Link } from 'react-router';
import { useEnvironmentShortcut } from '@common/hooks/use-environment-shortcut';

export type GeneralErrorProps = {
  error?: Error | null;
};

export const GeneralError: FC<GeneralErrorProps> = ({ error }) => {
  const [t] = useTranslation();
  const env = useEnvironmentShortcut();

  useEffect(() => {
    if (env !== 'local') {
      return;
    }

  }, [error]);

  return <Container>
    <div className={classes.root}>
      <InfoBox className={classes.infoBox} color='danger' headline={t('common.general-error.title')} >
        <Typography>{t('common.general-error.description')}</Typography>

        {!!error && <Card className={classes.card} >
          <Collapsible title={({ open }) => (
            <Card.Header divider={open}
              suffix={<IconButton
                label="Open"
                variant="plain">
                <Icon icon={['far', open ? 'chevron-up' : 'chevron-down']} />
              </IconButton>}>
              <Typography>
                {t('common.general-error.error-details')}
              </Typography>
            </Card.Header>)}>
            <Card.Content>
              <Typography>{error.message}</Typography>
              <pre>{error.stack}</pre>
            </Card.Content>
          </Collapsible>
        </Card>}

        <div className={classes.actions}>
          <Button role='button' as={Link} to="/" color="primary">
            {t('common.general-error.go-home')}
          </Button>
        </div>
      </InfoBox>
    </div>
  </Container>;
};